module.exports = __webpack_public_path__ + "img/video.36cc7193.png";